export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9003.34ac31b4.jpg";